import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Input, Alert } from '@dreamtree-org/twreact-ui';
import { errorText } from '@/lib/format';
import { useMutation } from '@/lib/useQuery';
import { VendorAuthFrame } from './SignIn';
import { PASSWORD_HINT } from '../lib/password';

const EMPTY = { business_name: '', contact_name: '', email: '', phone: '', gstin: '', password: '' };

/** Apply to sell. The store approves the request; until then the vendor can only see its status. */
export default function Apply({ store }) {
  const nav = useNavigate();
  const apply = useMutation('vendorApply');
  const [form, setForm] = useState(EMPTY);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: k === 'gstin' ? e.target.value.toUpperCase() : e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await apply.run(form);
      setSent(true);
    } catch (ex) {
      setError(errorText(ex));
    }
  };

  if (sent) {
    return (
      <VendorAuthFrame store={store} title="Request sent" subtitle="The store reviews every vendor request.">
        <Alert variant="success" title="Thanks for applying">Sign in with the email and password you chose to check the status of your request. Once approved you can list products.</Alert>
        <Button className="w-full" onClick={() => nav('/login')}>Go to sign in</Button>
      </VendorAuthFrame>
    );
  }

  return (
    <VendorAuthFrame store={store} title="Apply to sell" subtitle={`List your products on ${(store && store.name) || 'this store'}. The store approves each vendor and each product.`}>
      <form className="space-y-3" onSubmit={submit}>
        <Input label="Business name" value={form.business_name} onChange={set('business_name')} required maxLength={160} />
        <Input label="Your name" value={form.contact_name} onChange={set('contact_name')} required maxLength={120} />
        <div className="grid gap-3 sm:grid-cols-2">
          <Input label="Email" type="email" autoComplete="email" value={form.email} onChange={set('email')} required />
          <Input label="Phone" inputMode="tel" autoComplete="tel" value={form.phone} onChange={set('phone')} required />
        </div>
        <Input label="GSTIN" value={form.gstin} onChange={set('gstin')} helperText="Optional" maxLength={15} />
        <Input label="Password" type="password" autoComplete="new-password" value={form.password} onChange={set('password')} required helperText={PASSWORD_HINT} />
        {error ? <Alert variant="error" title="Not sent">{error}</Alert> : null}
        <Button type="submit" className="w-full" loading={apply.loading}>Send request</Button>
      </form>
      <p className="text-sm text-center opacity-80">Already a vendor? <Link className="font-medium underline" to="/login">Sign in</Link></p>
    </VendorAuthFrame>
  );
}
